<template>
  <v-snackbar
    v-model="snackBar.show"
    :color="snackBar.config.color"
    :multi-line="snackBar.config.multi_line"
    :top="snackBar.config.top"
    :bottom="snackBar.config.bottom"
    :left="snackBar.config.left"
    :right="snackBar.config.right"
    :timeout="snackBar.config.timeout"
  >
    <!-- One structure for every toast: state icon, message, dismiss.
         Colour alone carried the outcome before — which is invisible to anyone
         who cannot separate the green from the red, and ambiguous for everyone
         else in the corner of a busy screen. The icon says it outright. -->
    <div class="snack">
      <v-icon class="snack__icon" color="white" size="20">{{ stateIcon }}</v-icon>
      <div class="snack__msg">{{ snackBar.config.message }}</div>
      <v-btn
        v-if="snackBar.config.action"
        text
        small
        dark
        class="snack__action"
        @click="followAction"
      >
        {{ snackBar.config.action.text || "Open" }}
      </v-btn>
      <v-btn
        v-if="!$store.state.showMenu"
        icon
        small
        dark
        class="snack__close"
        aria-label="Dismiss"
        @click="closeSnackBar"
      >
        <v-icon size="18" color="white">mdi-close</v-icon>
      </v-btn>
    </div>
  </v-snackbar>
</template>

<script>
import { mapActions } from "vuex";
export default {
  name: "SnackBar",
  computed: {
    snackBar() {
      return this.$store.state.snackBar;
    },
    // The store has already normalised "s"/"e"/"w" to the theme colour names,
    // so match on those.
    stateIcon() {
      const color = String(this.snackBar.config.color || "").toLowerCase();
      if (color.indexOf("error") === 0) return "mdi-alert-circle-outline";
      if (color.indexOf("warning") === 0) return "mdi-alert-outline";
      if (color.indexOf("info") === 0) return "mdi-information-outline";
      return "mdi-check-circle-outline";
    },
  },
  methods: {
    ...mapActions({ closeSnack: "snackBar/hideToast" }),
    closeSnackBar() {
      this.closeSnack();
    },
    followAction() {
      const action = this.snackBar.config.action;
      this.closeSnack();
      if (!action || !action.to) return;
      // Already there (e.g. queued from the Reports page itself) -- a push
      // to the same route would only log a NavigationDuplicated error.
      this.$router.push(action.to).catch(() => {});
    },
  },
};
</script>

<style scoped>
.snack {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin: 0;
}

.snack__icon {
  flex: 0 0 auto;
  margin-top: 1px;
}

/* `text-capitalize` used to sit on this row, so every toast rendered
   Title Case Regardless Of What It Said — "Otp Sent Successfully",
   "Invalid Ifsc Code". Messages arrive already written; print them. */
.snack__msg {
  flex: 1 1 auto;
  min-width: 0;
  font-size: 13.5px;
  font-weight: 500;
  line-height: 1.45;
  overflow-wrap: anywhere;
}

.snack__action {
  flex: 0 0 auto;
  margin: -4px 0 0 4px;
  font-weight: 700;
  letter-spacing: 0;
  text-transform: none;
}

.snack__close {
  flex: 0 0 auto;
  margin: -2px -4px 0 4px;
  opacity: 0.85;
}
.snack__close:hover {
  opacity: 1;
}
</style>
